import { Button as BaseUIButton, ButtonProps as BaseUIButtonProps } from "@base-ui/react/button";
import { resolveRelationshipId } from "@/lib/utils/theme-configuration-class";
import { cn } from "@/lib/utils";
import { Button as ButtonT } from "@/payload-types";
import { Relationship } from "@/lib/utils/theme-configuration-class";
import AnchorLink from "../anchor-link";
import PageLink from "../page-link";
import "./style.scss";
import Icon, { IconName } from "../icon";

export type ButtonVariant = Relationship<ButtonT> | "default" | "subtle" | "destructive";

export interface ButtonProps extends BaseUIButtonProps {
	children?: React.ReactNode;
	variant?: ButtonVariant;
	className?: string;
	href?: string;
	active?: boolean;
	iconStart?: IconName;
	iconEnd?: IconName;
	target?: React.HTMLAttributeAnchorTarget;
}

export const Button: React.FC<ButtonProps> = ({
	children,
	href,
	variant = "default",
	className,
	active,
	nativeButton = true,
	iconEnd,
	iconStart,
	...props
}) => {
	const variantId = resolveRelationshipId(variant) ?? "default";
	const LinkComponent = href?.includes("#") ? AnchorLink : PageLink;

	return (
		<BaseUIButton
			nativeButton={href ? false : nativeButton}
			render={href ? <LinkComponent href={href} /> : !nativeButton ? <span /> : undefined}
			className={cn(
				"transition flex gap-2 justify-center items-center cursor-pointer border-box border-transparent select-none data-disabled:opacity-50",
				"ms-btn-" + variantId,
				active && "active",
				className,
			)}
			{...props}
		>
			{iconStart && <Icon name={iconStart} />}
			{children && children}
			{iconEnd && <Icon name={iconEnd} />}
		</BaseUIButton>
	);
};
